import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'arrow-bear-right', 'ArrowBearRight', [["path",{"d":"M12 3h5v5"}],["path",{"d":"M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"}]]);